import React from 'react';
import { useTranslation } from 'react-i18next';

import { ApprovedSupplier } from '../../services/types';

interface PartApprovedSuppliersTableProps {
  approvedSuppliers: ApprovedSupplier[];
}

export const PartApprovedSuppliersTable: React.FC<
  PartApprovedSuppliersTableProps
> = ({ approvedSuppliers }) => {
  const { t } = useTranslation();

  return (
    <div className="bg-white rounded border border-gray-300 shadow-sm flex flex-col">
      {/* Header */}
      <div className="bg-indigo-50 px-4 py-3 border-b border-indigo-200 flex-shrink-0">
        <h3 className="text-lg font-bold text-indigo-900">
          {t('parts.approvedSuppliers')}
        </h3>
        <p className="text-xs text-indigo-700">
          {approvedSuppliers.length}{' '}
          {approvedSuppliers.length === 1
            ? t('parts.records')
            : t('parts.recordPlural')}
        </p>
      </div>

      {/* Content */}
      {approvedSuppliers.length > 0 ? (
        <div className="overflow-x-auto flex-grow">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-gray-100 border-b border-gray-200 sticky top-0">
                <th className="px-4 py-3 text-left font-semibold text-gray-700">
                  {t('parts.approvedSuppliersTable.supplier')}
                </th>
                <th className="px-4 py-3 text-left font-semibold text-gray-700">
                  {t('parts.approvedSuppliersTable.supplierPartNum')}
                </th>
              </tr>
            </thead>
            <tbody>
              {approvedSuppliers.map((record, idx) => (
                <tr key={idx} className="hover:bg-gray-50 transition-colors">
                  <td className="px-4 py-3 text-gray-900 font-medium">
                    {record.vendorName || '-'}
                  </td>
                  <td className="px-4 py-3 text-gray-700">
                    {record.venPartNum || '-'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="p-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="pb-2">
              <p className="text-xs font-semibold text-gray-600 uppercase tracking-tight mb-1">
                {t('parts.approvedSuppliersTable.supplier')}
              </p>
              <p className="text-sm font-medium text-gray-900">-</p>
            </div>
            <div className="pb-2">
              <p className="text-xs font-semibold text-gray-600 uppercase tracking-tight mb-1">
                {t('parts.approvedSuppliersTable.supplierPartNum')}
              </p>
              <p className="text-sm font-medium text-gray-900">-</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
